// -- import * as _ from "lodash-es"
import * as _date from "date-fns"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "SalesTable"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      type: "button",
      button: {
        type: "text"
      },
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "SalesId",
      label: "平台销售订单编号",
      sortable: true
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      type: "short"
    },
    {
      key: "SEI_BigCustomerNumber",
      label: "TOP客户组",
      sortable: true,
      thStyle: {
        width: "10rem"
      },
      type: "short"
    },
    {
      key: "CustAccount",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "SalesName",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "DeliveryAddress",
      label: "送货地址",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "InvoiceAccount",
      label: "发票帐户",
      sortable: true
    },
    {
      key: "DeliveryDate",
      label: "装运日期",
      sortable: true,
      type: "date"
    },
    {
      key: "OrderAmount",
      label: "订单金额",
      sortable: true,
      type: "number",
      _precise: 2,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "OrderAmountWOTax",
      label: "本币不含税金额",
      sortable: true,
      type: "number",
      _precise: 2,
      thStyle: { width: "8rem" }
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },
    {
      key: "ExchRate",
      label: "汇率",
      sortable: true,
      type: "number",
      thStyle: { width: "80px" },
      _precise: 4
    },
    {
      key: "TaxGroup",
      label: "销售税组",
      sortable: true
    },
    {
      key: "SalesPoolId",
      label: "池",
      sortable: true
    },
    {
      key: "InclTax",
      label: "价格包括销售税",
      sortable: true
    },

    {
      key: "TEC_Remark",
      label: "备注",
      sortable: true
    },
    {
      key: "TEC_FinalCustAccount",
      label: "最终客户",
      sortable: true
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "update_by",
      label: "修改人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.update_by_username
      }
    },
    {
      key: "update_at",
      label: "修改时间",
      sortable: true,
      type: "datetime"
    },

    {
      key: "SOApprover",
      label: "订单待审批人",
      sortable: true,
      thStyle: {
        width: "12rem"
      }
    },

    {
      key: "fcCheckSOApproved",
      label: "订单审批",
      sortable: true,
      type: "state",
      other_type_key: "is_email_send",
      state_control: "fcCheckSOApproved",
      context: ["待审批", "已审批", "审批中"]
    },
    {
      key: "SOApprovedState",
      label: "订单审批状态名称",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
      formatter: (value, key, item) => {
        if (item.fcCheckSOApproved) {
          item.SOApprovedState = "已审批"
          return "已审批"
        } else if (item.is_email_send) {
          item.SOApprovedState = "审批中"
          return "审批中"
        } else {
          item.SOApprovedState = "待审批"
          return "待审批"
        }
      }
    },

    {
      key: "SOCreditControlApprover",
      label: "信用待审批人",
      sortable: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "approved_comment",
      label: "信用控制意见",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "fcCheckSOCreditControlApproved",
      label: "信用控制状态",
      sortable: true,
      type: "state",
      other_type_key: "is_email_send",
      context: ["待审批", "已审批", "审批中"]
    },
    {
      key: "SOCreditControlApprovedState",
      label: "信用审批状态名称",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
      formatter: (value, key, item) => {
        if (item.fcCheckSOCreditControlApproved) {
          item.SOCreditControlApprovedState = "已审批"
          return "已审批"
        } else if (item.is_email_send) {
          item.SOCreditControlApprovedState = "审批中"
          return "审批中"
        } else {
          item.SOCreditControlApprovedState = "待审批"
          return "待审批"
        }
      }
    },
    {
      key: "SOPriceDiffApprover",
      label: "价格待审批人",
      sortable: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "fcCheckSOPriceDffApproved",
      label: "价格审批",
      sortable: true,
      type: "state",
      other_type_key: "is_email_send",
      context: ["待审批", "已审批", "审批中"]
    },
    {
      key: "SOPriceDffApprovedState",
      label: "价格审批状态名称",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
      formatter: (value, key, item) => {
        if (item.fcCheckSOPriceDffApproved) {
          item.SOPriceDffApprovedState = "已审批"
          return "已审批"
        } else if (item.is_email_send) {
          item.SOPriceDffApprovedState = "审批中"
          return "审批中"
        } else {
          item.SOPriceDffApprovedState = "待审批"
          return "待审批"
        }
      }
    }
  ],
  detail_fields: [
    {
      key: "LineNum",
      label: "行号",
      sortable: true,
      thStyle: {
        width: "80px"
      }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true,
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "DeliveryAddress",
      label: "送货地址",
      sortable: true,
      editable: true,
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "SalesQty",
      label: "数量",
      sortable: true,
      editable: true,
      type: "just_number"
    },
    {
      key: "SalesPrice",
      label: "价格",
      sortable: true,
      editable: true,
      type: "just_number",
      _precise: 6
    },
    {
      key: "DW_inventBatchIdSales",
      label: "仓库",
      sortable: true,
      editable: true
    },
    {
      key: "DiscPrice",
      label: "协议价格",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },
    {
      key: "SalesPriceWOTax",
      label: "本币净单价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "price_state",
      label: "价格状态",
      sortable: true,
      type: "icon"
    },
    {
      key: "ConfirmedDlv",
      label: "装运日期",
      sortable: true,
      editable: true,
      type: "date"
    },
    {
      key: "SEI_OrderDateCust",
      label: "客户订单日期",
      sortable: true,
      // editable: true,
      type: "date"
    },
    {
      key: "SEI_ShippingDateCust",
      label: "客户交期",
      sortable: true,
      // editable: true,
      type: "date",
      thStyle: {
        width: "100px"
      }
    },
    {
      key: "TEC_CommonRemark",
      label: "通用备注",
      sortable: true,
      editable: true,
      type: "textarea"
    },
    {
      key: "TEC_OtherInfo",
      label: "其他信息",
      sortable: true,
      editable: true,
      type: "textarea"
    },
    {
      key: "TEC_CustSalesID",
      label: "客户订单号",
      sortable: true,
      editable: true,
      type: "textarea"
    },

    {
      key: "RetailVariantId",
      label: "变型名称",
      sortable: true,
      // editable: true,
      width: "8rem",
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    },
    {
      key: "SEI_DimensionFG",
      label: "FG维度",
      sortable: true
    },
    {
      key: "valid_remain",
      label: "剩余派单数量",
      sortable: true,
      type: "number",
      _precise: 6
    }
  ],
  inventTable_fields: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },

    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      // type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "TEC_CustAccount",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "DW_CustName",
      label: "客户名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "10rem"
      }
    },

    {
      key: "TEC_NetArea",
      label: "净面积",
      sortable: true,
      type: "number"
    },
    {
      key: "TEC_Weight",
      label: "单位重量",
      sortable: true,
      type: "number"
    },
    {
      key: "DW_InventUnitId",
      label: "单位",
      sortable: true
    }
    // {
    //   key: "modifiedDateTime",
    //   label: "修改时间",
    //   type: "datetime",
    //   thStyle: { width: "5rem" }
    // }
  ]
}

const dataForm = {
  id: "",
  SalesId: "", //	销售订单编号
  SalesName: "", //	客户名称
  CustAccount: "", //	客户帐户
  InvoiceAccount: "", //	发票帐户
  DeliveryDate: new Date(), //	装运日期 date
  CurrencyCode: "CNY", //	币种
  ExchRate: "",
  TaxGroup: "", //	销售税组
  SalesPoolId: "", //	池
  InclTax: "", //	价格包括销售税
  TEC_Remark: "", //	备注
  TEC_FinalCustAccount: "", //	最终客户
  // createdBy: "", //	创建人
  dataAreaId: "", //	公司
  CreditMax: 0,
  Temp_CreditMax: 0,
  dispUsedCreditAmount: 0,
  CustomerNotDispatchAmt: 0,
  OrderAmount: 0,
  OrderAmountTax: 0, //含税本币金额
  OrderAmountWOTax: 0, //不含税本币金额
  DeliveryAddress: "" //送货地址
}
const creditdataForm = {
  id: "",
  AccountNum: "",
  dispUsedCreditAmount: 0,
  PlantUsedCreditAmount: 0,
  dispopenInvoiceBalanceMSTDue0: 0,
  dispopenInvoiceBalanceMSTDue_N: 0,
  dispopenInvoiceBalanceMSTDueAbove_N: 0,
  dispopenInvoiceBalanceMSTDue30: 0,
  dispopenInvoiceBalanceMSTDue31_60: 0,
  dispopenInvoiceBalanceMSTDue60Above: 0,
  dataAreaId: "",
  orderAmount: 0, //订单总金额
  creditMax: 0, //总信用额度
  approved_comment: "", //审批意见
  balance: 0 //余额
}

const dataItemForm = {
  id: "",
  SalesTable_id: "",
  SalesId: "", //销售订单
  LineNum: "", //行号
  ItemId: "", //物料编号
  NameAlias: "", //物料名称
  SalesStatus: "", //行状态
  Name: "", //文本
  TaxGroup: "", //销售税组
  QtyOrdered: "", //数量
  RemainSalesPhysical: "", //剩余交货量
  RemainSalesFinancial: "", //未开票数量
  SalesPrice: "", //价格
  DiscPrice: "", //协议价格
  CurrencyCode: "", //币种
  ConfirmedDlv: "", //装运日期
  SalesUnit: "", //单位
  SalesQty: "", //数量
  TaxItemGroup: "", //销售税(物料)组
  UnderDeliveryPct: "", //欠交
  OverDeliveryPct: "", //超交
  RemainInventFinancial: "", //未开票数量
  TEC_CommonRemark: "", //通用备注
  TEC_CustSalesID: "", //客户订单号
  TEC_LineAmountBak: "", //净额
  TEC_OtherInfo: "",
  SEI_OrderDateCust: "", //客户订单日期
  SEI_PriceUnitCust: "", //客户价格
  SEI_ShippingDateCust: "", //客户交期
  dataAreaId: "", //公司
  SEI_ProddataArea: "", //生产商
  valid_remain: "",
  RetailVariantId: "",
  VariantName: "",
  price_approved_state: 0,
  SalesPriceTax: 0,
  SalesPriceWOTax: 0,
  DW_inventBatchIdSales: "", //库位 add 2021/7/5
  DeliveryAddress: "" //送货地址
}

///前端验证
const rules = {
  CustAccount: [
    {
      required: true,
      message: "请选择客户账户",
      trigger: "change"
    }
  ],
  TEC_FinalCustAccount: [
    {
      required: true,
      message: "请选择最终客户",
      trigger: "change"
    }
  ],
  InvoiceAccount: [
    {
      required: true,
      message: "请选择开票账户",
      trigger: "change"
    }
  ],
  SalesPoolId: [
    {
      required: true,
      message: "请选择订单池",
      trigger: "change"
    }
  ],
  dataAreaId: [
    {
      required: true,
      message: "请选择公司",
      trigger: "change"
    }
  ],
  TaxGroup: [
    {
      required: true,
      message: "请选择销售税组",
      trigger: "change"
    }
  ],
  ExchRate: [
    {
      required: true,
      message: "请输入汇率",
      trigger: "change"
    }
  ],
  DeliveryDate: [
    {
      type: "date",
      required: true,
      message: "装运日期",
      trigger: "change"
    }
  ]
  // TEC_Remark: [{ required: true, message: "请填写活动形式", trigger: "blur" }]
}

const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res)
            } else {
              reject("测试没通过")
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
const methods = {
  async copySalesOrder(_params) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "CopySalesOrder",
      {},
      {}
    )
    let _fields = []

    let result = await code_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()
    //
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //#region 订单主档相关
  ///get all role_username
  async getAllRoleUserName() {
    const ru_biz_data = new biz_data_helper.base_entity_helper(
      "get_all_rolecode_username",
      {},
      {}
    )
    let _fields = ["username", "role_code"]

    let result = await ru_biz_data
      .execAction({
        params: {},
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///get salesorder
  async getData(_params) {
    let _fields = _.map(fields.default, "key")

    _fields.push("OrderAmountTax")
    _fields.push("fcGetSOApprover(t.id)")
    _fields.push("fcGetSOCreditControlApprover(t.id)")
    _fields.push("fcGetSOPriceDiffApprover(t.id)")
    _fields.push("fcCheckSOApproved(t.id)")
    _fields.push("fcCheckSOCreditControlApproved(t.id)")
    _fields.push("fcCheckSOPriceDffApproved(t.id)")

    _fields.push("CreditMax")
    _fields.push("Temp_CreditMax")
    _fields.push("dispUsedCreditAmount")
    _fields.push("CustomerNotDispatchAmt")
    _fields.push("is_return_so")
    _fields.push("is_email_send")

    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getDefualtCompanyTaxGroup(dataAreaId) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_defualt_Company_TaxGroup",
      {},
      {}
    )
    let result = await code_biz_data
      .execAction({
        params: {
          dataAreaId: dataAreaId
        },
        fields: ["TaxGroup"]
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //保存转单信息
  async saveToSaleOrder(saleMaster, saleLines, documentCreateByUsername) {
    let _actions = []
    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus",
      {},
      {}
    )

    let _new = _.cloneDeep(saleMaster)

    delete saleMaster.documentCreateByUsername

    ///保存

    delete _new.id
    delete _new.documentCreateByUsername
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_seq",
      {},
      {}
    )

    //获取code
    let _p = {
      type: "CSO",
      date: _date.format(new Date(), "yyyy-MM-dd")
    }
    _actions.push(
      code_biz_data
        .execAction({
          params: _p,
          fields: ["seq"]
        })
        .action({
          output_last_item_map: {
            seq: "SalesId"
          }
        })
    )
    _actions.push(
      biz_data
        .insertAction({
          params: _new,
          fields: _.map(fields.default, "key")
        })
        .action({
          mixin_last_item_map: {
            SalesId: "SalesId"
          },
          output_last_item_map: {
            id: "itemId"
          }
        })
    )

    ///价格不一致特批
    // let price_form = {
    //   itemId: "",
    //   documentType: "SalesOrder",
    //   approveType: "price_diff", //审批类型：credit_control：信用额度，price_diff：价格
    //   documentCreateByUsername: documentCreateByUsername,
    //   salesOrderAmountCNY: 0,
    //   isPriceDiff: true
    // };
    // _actions.push(
    //   so_approve_biz_data
    //   .execAction({
    //     params: price_form,
    //     fields: ["id"]
    //   })
    //   .action({
    //     mixin_last_item_map: {
    //       itemId: "itemId"
    //     }
    //   })
    // );

    // ///信用额度特批
    // let credit_form = {
    //   itemId: "",
    //   documentType: "SalesOrder",
    //   approveType: "credit_control", //审批类型：credit_control：信用额度，price_diff：价格
    //   documentCreateByUsername: documentCreateByUsername,
    //   salesOrderAmountCNY: 0,
    //   IsCreditControlOk: false
    // };
    // _actions.push(
    //   so_approve_biz_data
    //   .execAction({
    //     params: credit_form,
    //     fields: ["id"]
    //   })
    //   .action({
    //     mixin_last_item_map: {
    //       itemId: "itemId"
    //     }
    //   })
    // );

    // ///普通审批
    // let order_form = {
    //   itemId: "",
    //   documentType: "SalesOrder",
    //   approveType: "",
    //   documentCreateByUsername: documentCreateByUsername,
    //   salesOrderAmountCNY: 0
    // };
    // _actions.push(
    //   so_approve_biz_data
    //   .execAction({
    //     params: order_form,
    //     fields: ["id"]
    //   })
    //   .action({
    //     mixin_last_item_map: {
    //       itemId: "itemId"
    //     }
    //   })
    // );
    //插入saleLine
    _.each(saleLines, t => {
      let _data = {}
      _data.id = ""
      _data.TaxGroup = saleMaster.TaxGroup
      _data.CurrencyCode = saleMaster.CurrencyCode
      _data.dataAreaId = saleMaster.dataAreaId
      _data.SalesPriceWOTax = 0
      _data.SalesPriceTax = 0
    })

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let _list = null

      let _rt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/i/SalesTable"
      })
      if (
        _rt &&
        _rt[0].Result &&
        !_.isNull(_rt[0].Result) &&
        _rt[0].Result.Data &&
        !_.isNull(_rt[0].Result.Data) &&
        _rt[0].Result.Data.length > 0
      ) {
        _list = _rt[0].Result.Data[0]
      }
      return _list
    } else {
      return null
    }
  },
  ///save salesorder
  async saveSalesOrder(_params, documentCreateByUsername) {

    let _actions = []
    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus",
      {},
      {}
    )

    let _new = _.cloneDeep(_params)

    delete _params.documentCreateByUsername

    ///保存
    if (!_.isInteger(_params.id)) {
      delete _new.id
      delete _new.documentCreateByUsername
      const code_biz_data = new biz_data_helper.base_entity_helper(
        "get_seq",
        {},
        {}
      )

      //获取code
      let _p = {
        type: "CSO",
        date: _date.format(new Date(), "yyyy-MM-dd")
      }
      _actions.push(
        code_biz_data
          .execAction({
            params: _p,
            fields: ["seq"]
          })
          .action({
            output_last_item_map: {
              seq: "SalesId"
            }
          })
      )
      _actions.push(
        biz_data
          .insertAction({
            params: _new,
            fields: _.map(fields.default, "key")
          })
          .action({
            mixin_last_item_map: {
              SalesId: "SalesId"
            },
            output_last_item_map: {
              id: "itemId"
            }
          })
      )

      ///价格不一致特批
      let price_form = {
        itemId: "",
        documentType: "SalesOrder",
        approveType: "price_diff", //审批类型：credit_control：信用额度，price_diff：价格
        documentCreateByUsername: documentCreateByUsername,
        salesOrderAmountCNY: 0,
        isPriceDiff: true
      }
      _actions.push(
        so_approve_biz_data
          .execAction({
            params: price_form,
            fields: ["id"]
          })
          .action({
            mixin_last_item_map: {
              itemId: "itemId"
            }
          })
      )

      ///信用额度特批
      let credit_form = {
        itemId: "",
        documentType: "SalesOrder",
        approveType: "credit_control", //审批类型：credit_control：信用额度，price_diff：价格
        documentCreateByUsername: documentCreateByUsername,
        salesOrderAmountCNY: 0,
        IsCreditControlOk: false
      }
      _actions.push(
        so_approve_biz_data
          .execAction({
            params: credit_form,
            fields: ["id"]
          })
          .action({
            mixin_last_item_map: {
              itemId: "itemId"
            }
          })
      )

      ///普通审批
      let order_form = {
        itemId: "",
        documentType: "SalesOrder",
        approveType: "",
        documentCreateByUsername: documentCreateByUsername,
        salesOrderAmountCNY: 0
      }
      _actions.push(
        so_approve_biz_data
          .execAction({
            params: order_form,
            fields: ["id"]
          })
          .action({
            mixin_last_item_map: {
              itemId: "itemId"
            }
          })
      )
    } else {
      let _fields = _.map(fields.default, "key")
      _fields.push("CreditMax")
      _fields.push("Temp_CreditMax")
      _fields.push("dispUsedCreditAmount")
      _fields.push("CustomerNotDispatchAmt")
      let _p = _.cloneDeep(_params)
      _p["is_email_send"] = 0

      _actions.push(
        biz_data
          .updateAction({
            params: _p,
            fields: _fields
          })
          .action({})
      )
    }

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let _list = null
      if (!_.isInteger(_params.id)) {
        let _rt = _.filter(result.data.BatchResult.Actions, {
          Code: "data/i/SalesTable"
        })
        if (
          _rt &&
          _rt[0].Result &&
          !_.isNull(_rt[0].Result) &&
          _rt[0].Result.Data &&
          !_.isNull(_rt[0].Result.Data) &&
          _rt[0].Result.Data.length > 0
        ) {
          _list = _rt[0].Result.Data[0]
        }
        return _list
      } else {
        let _rt = _.filter(result.data.BatchResult.Actions, {
          Code: "data/u/SalesTable"
        })
        if (
          _rt &&
          _rt[0].Result &&
          !_.isNull(_rt[0].Result) &&
          _rt[0].Result.Data &&
          !_.isNull(_rt[0].Result.Data) &&
          _rt[0].Result.Data.length > 0
        ) {
          _list = _rt[0].Result.Data[0]
        }
        return _list
      }
    } else {
      return null
    }
  },
  ///del salesorder
  async deleteData(items) {
    let _actions = []

    let check_del_biz_data = new biz_data_helper.base_entity_helper(
      "CheckIfExistsSalesLine",
      {},
      {}
    )
    let del_biz_data = new biz_data_helper.base_entity_helper(
      "delete_salesorder",
      create,
      descriptor
    )
    let cancel_email_biz_data = new biz_data_helper.base_entity_helper(
      "cancel_email_send",
      {},
      {}
    )

    _.each(items, t => {
      _actions.push(
        check_del_biz_data
          .execAction({
            params: {
              itemId: t.id
            },
            fields: ["has_SalesLine"]
          })
          .action({
            output_last_item_map: {
              has_SalesLine: "has_SalesLine"
            }
          })
      )
      _actions.push(
        del_biz_data
          .execAction({
            params: {
              id: t.id
            }
          })
          .action({
            rollback_when: {
              has_SalesLine: {
                "=": 1
              }
            }
          })
      )
      ///取消邮件
      _actions.push(
        cancel_email_biz_data
          .execAction({
            params: {
              type: "so",
              idx: _.toString(t.SalesId)
            }
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },

  ///approved salesorder
  async approveData(username, _update_status_list) {
    const update_status_biz_data = new biz_data_helper.base_entity_helper(
      "update_approve_status",
      {},
      {}
    )
    let _actions = []
    _.each(_update_status_list, status_m => {
      _actions.push(
        update_status_biz_data
          .execAction({
            params: {
              IsApproved: status_m.isApproved ? 0 : 1,
              ApproveBy: username,
              status_id: status_m.id
            },
            fields: ["is_update_ok"]
          })
          .action({
            output_last_item_map: {
              is_update_ok: "is_update_ok"
            }
          })
      )
      ///反审时将邮件状态修改为未发送
      if (status_m.isApproved) {
        _actions.push(
          biz_data
            .updateAction({
              params: {
                id: status_m.ItemId,
                is_email_send: 0
              }
            })
            .action({
              rollback_when: {
                is_update_ok: {
                  "=": 1
                }
              }
            })
        )
      }
    })

    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let _is_ok = true
      let _result_filter = _.filter(result.data.BatchResult.Actions, {
        Code: "data/e/update_approve_status"
      })
      if (_result_filter && _result_filter.length > 0) {
        _.each(_result_filter, t => {
          if (t.Result.Data[0][0].is_update_ok == 1) {
            _is_ok = false
          }
        })
      }
      return _is_ok
    } else {
      return false
    }
  },
  async getApproveStatus(_params) {
    const get_status_biz_data = new biz_data_helper.base_entity_helper(
      "get_approve_status",
      {},
      {}
    )
    let result = await get_status_biz_data
      .execAction({
        params: _params,
        fields: ["id", "Approver", "isRole "]
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //#endregion

  //#region 订单明细相关
  ///get disc 获取价格协议
  async getDiscPrice(_params) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_price",
      {},
      {}
    )
    let result = await code_biz_data
      .execAction({
        params: _params
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //获取勾选订单对应的所有明细
  async getItemDataBySelected(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "get_SalesLineInfo",
      {},
      {}
    )
    let _fields = _.map(fields.detail_fields, "key")
    _fields.push("id")
    _fields.push("SalesTable_id")
    _fields.push("SalesId")

    _.remove(_fields, n => {
      return n == "price_state"
    })
    let _actions = []
    _.each(_params, t => {
      _actions.push(
        item_biz_data
          .execAction({
            params: {
              SalesTable_id: t.SalesTable_id
            },
            fields: _fields
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  ///查询已经派单数量
  async getDispatchedQty(SOId) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "getTotalDispatchQty",
      create,
      descriptor
    )
    let result = await item_biz_data
      .execAction({
        params: {
          SalesOrderId: SOId
        },
        fields: ["totalDispatchedQty"]
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///get so items
  async getItemData(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "get_SalesLineInfo",
      {},
      {}
    )
    let _fields = _.map(fields.detail_fields, "key")
    _fields.push("id")
    _fields.push("SalesTable_id")
    _fields.push("SalesId")

    _.remove(_fields, n => {
      return n == "price_state"
    })
    let result = await item_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getItemDataNoSql(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "SalesLine",
      {},
      {}
    )
    let _fields = _.map(fields.detail_fields, "key")
    _fields.push("id")
    _fields.push("SalesTable_id")
    _fields.push("SalesId")

    _.remove(_fields, n => {
      return n == "price_state"
    })
    let result = await item_biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },

  ///save so items
  async saveSalesOrderItems(items, soForm, update_order_amount) {
    let add_list = [],
      update_list = []

    _.each(items, t => {
      if (_.isInteger(t.id)) {
        update_list.push(t)
      } else {
        add_list.push(t)
      }
    })
    let check_biz_data = new biz_data_helper.base_entity_helper(
      "CheckIfCanModifySalesLine",
      {},
      {}
    )

    let item_biz_data = new biz_data_helper.base_entity_helper(
      "SalesLine",
      create,
      descriptor
    )

    let so_biz_data = new biz_data_helper.base_entity_helper(
      "SalesTable",
      {},
      {}
    )

    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus",
      {},
      {}
    )

    let _is_price_diff = false
    let batch_actions = []
    if (add_list.length > 0) {
      _.each(add_list, t => {
        let _new = _.cloneDeep(dataItemForm)
        for (var i in _new) {
          _new[i] = t[i]
        }
        delete _new.id

        batch_actions.push(
          item_biz_data
            .insertAction({
              params: _new,
              fields: ["id"]
            })
            .action({
              output_last_item_map: {
                id: "SalesLine_id"
              }
            })
        )
        ///价格不一致特批
        if (t.SalesPrice != t.DiscPrice || !_.isNumber(t.DiscPrice)) {
          _is_price_diff = true
        }
      })
    }

    if (update_list.length > 0) {
      _.each(update_list, t => {
        let _new = _.cloneDeep(dataItemForm)
        for (var i in _new) {
          _new[i] = t[i]
        }
        batch_actions.push(
          check_biz_data
            .execAction({
              params: {
                SalesLineId: t.id,
                action: "update",
                inputQty: _new.SalesQty
              },
              fields: ["allowed"]
            })
            .action({
              output_last_item_map: {
                allowed: "allowed"
              }
            })
        )

        batch_actions.push(
          item_biz_data
            .updateAction({
              params: _new,
              fields: ["id"]
            })
            .action({
              rollback_when: {
                allowed: {
                  "=": false
                }
              }
            })
        )

        ///价格不一致特批
        if (t.SalesPrice != t.DiscPrice || !_.isNumber(t.DiscPrice)) {
          _is_price_diff = true
        }
      })
    }

    ///价格不一致特批
    let price_form = {
      itemId: soForm.id,
      documentType: "SalesOrder",
      approveType: "price_diff", //审批类型：credit_control：信用额度，price_diff：价格
      documentCreateByUsername: soForm.documentCreateByUsername,
      salesOrderAmountCNY: soForm.salesorder_amount_cny,
      isPriceDiff: _is_price_diff
    }
    batch_actions.push(
      so_approve_biz_data
        .execAction({
          params: price_form,
          fields: ["id"]
        })
        .action({})
    )

    ///信用额度特批
    let credit_form = {
      itemId: soForm.id,
      documentType: "SalesOrder",
      approveType: "credit_control", //审批类型：credit_control：信用额度，price_diff：价格
      documentCreateByUsername: soForm.documentCreateByUsername,
      salesOrderAmountCNY: soForm.salesorder_amount_cny,
      IsCreditControlOk: soForm.IsCreditControlOk
    }
    batch_actions.push(
      so_approve_biz_data
        .execAction({
          params: credit_form,
          fields: ["id"]
        })
        .action({})
    )

    ///普通审批
    let order_form = {
      itemId: soForm.id,
      documentType: "SalesOrder",
      approveType: "",
      documentCreateByUsername: soForm.documentCreateByUsername,
      salesOrderAmountCNY: update_order_amount.OrderAmountCNY
    }
    batch_actions.push(
      so_approve_biz_data
        .execAction({
          params: order_form,
          fields: ["id"]
        })
        .action({})
    )

    ///修改订单信用控制状态
    batch_actions.push(
      so_biz_data
        .updateAction({
          params: {
            id: update_order_amount.id,
            OrderAmount: update_order_amount.OrderAmount,
            OrderAmountTax: update_order_amount.OrderAmountTax,
            OrderAmountWOTax: update_order_amount.OrderAmountWOTax,
            CreditMax: update_order_amount.CreditMax,
            Temp_CreditMax: update_order_amount.Temp_CreditMax,
            dispUsedCreditAmount: update_order_amount.dispUsedCreditAmount,
            CustomerNotDispatchAmt: update_order_amount.PlantUsedCreditAmount,
            is_email_send: 0
          },
          fields: ["id"]
        })
        .action({})
    )
    ///查询当前保存的订单数据
    let _fields = _.map(fields.default, "key")

    _fields.push("OrderAmountTax")
    _fields.push("fcGetSOApprover(t.id)")
    _fields.push("fcGetSOCreditControlApprover(t.id)")
    _fields.push("fcGetSOPriceDiffApprover(t.id)")
    _fields.push("fcCheckSOApproved(t.id)")
    _fields.push("fcCheckSOCreditControlApproved(t.id)")
    _fields.push("fcCheckSOPriceDffApproved(t.id)")

    _fields.push("CreditMax")
    _fields.push("Temp_CreditMax")
    _fields.push("dispUsedCreditAmount")
    batch_actions.push(
      so_biz_data
        .selectAction({
          params: {
            id: update_order_amount.id
          },
          fields: _fields
        })
        .action({})
    )

    let result = await api.query_batch({
      actions: batch_actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  ///del so items
  async deleteItemData(items) {
    let _actions = []

    let check_biz_data = new biz_data_helper.base_entity_helper(
      "CheckIfCanModifySalesLine",
      {},
      {}
    )

    let item_biz_data = new biz_data_helper.base_entity_helper(
      "SalesLine",
      create,
      descriptor
    )
    let order_biz_data = new biz_data_helper.base_entity_helper(
      "SalesTable",
      {},
      {}
    )
    _.each(items, t => {
      _actions.push(
        check_biz_data
          .execAction({
            params: {
              SalesLineId: t.id,
              action: "delete",
              inputQty: 0
            },
            fields: ["allowed"]
          })
          .action({
            output_last_item_map: {
              allowed: "allowed"
            }
          })
      )
      _actions.push(
        item_biz_data
          .deleteAction({
            params: {
              id: t.id
            }
          })
          .action({
            rollback_when: {
              allowed: {
                "=": false
              }
            }
          })
      )
      if (t.SalesQty < 0) {
        _actions.push(
          order_biz_data
            .deleteAction({
              params: {
                id: t.SalesTable_id
              }
            })
            .action({
              rollback_when: {
                allowed: {
                  "=": false
                }
              }
            })
        )
      }
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  //#endregion
  ///get当前不含税金额
  async getLocalAmountWOTaxData(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "get_LocalAmountWOTax",
      {},
      {}
    )
    // "CNYAmount": 11.2887,
    // "CNYAmountWOTax": 9.99,
    // "currency": "usd",
    // "amount": 1,
    // "incTax": false,
    // "taxGroup": "VT13",
    // "dataAreaId": "070"
    // let _fields = ["CNYAmount","CNYAmountWOTax","currency"];

    let result = await item_biz_data
      .execAction({
        params: _params
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getPlantCustUsedCredit(_params) {
    const gcrc_biz_data = new biz_data_helper.base_entity_helper(
      "get_plant_customer_used_credit",
      {},
      {}
    )

    let result = await gcrc_biz_data
      .execAction({
        params: _params,
        fields: ["plant_customer_used_credit"]
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///检查能否反审
  async checkUnApprove(items) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "check_is_salesorder_dispatched",
      {},
      {}
    )
    let _actions = []
    let _params = []
    _.each(items, t => {
      _params.push({
        SalesOrderId: t.id
      })
    })
    _actions.push(
      code_biz_data
        .execAction({
          params: _params,
          fields: ["if_can_unapprove", "SalesOrderId"]
        })
        .action({})
    )
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let _p = {
        state: true,
        data: [],
        message: ""
      }
      let rt_actions = result.data.BatchResult.Actions[0]
      if (
        rt_actions.Result &&
        rt_actions.Result.Data &&
        rt_actions.Result.Data.length > 0
      ) {
        _.each(rt_actions.Result.Data, t => {
          if (t[0].if_can_unapprove == 0) {
            _p.state = false
            _p.data.push(t[0].SalesOrderId)
          }
        })
      }
      if (!_p.state) {
        _p.message =
          "订单编号：" + _.join(_p.data, "，") + "，已派单不能被删除！"
      }
      return _p
    } else {
      return null
    }
  },
  ///获取送货地址列表
  async getDeliveryAddress(_params) {
    const gcda_biz_data = new biz_data_helper.base_entity_helper(
      "get_customer_delivery_address",
      {},
      {}
    )

    let result = await gcda_biz_data
      .execAction({
        params: _params,
        fields: ["DeliveryAddress"]
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  }
}
export {
  biz_data, creditdataForm,
  dataForm,
  dataItemForm, fields,
  methods, rules
}

